import React from 'react';
import { Text, View, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import {
  NavBar,
  Members,
  OPComponent,
  IconButton,
  Container,
  ActivityOverlay,
  Utils,
  Navigation,
  I18n,
} from '../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { resetState } from './actions';
import { getCurrentCase, getEditingCase } from '../cases/selector';
import { pendingInvitesForCase } from '../../services/inviteService';
import { INVITATIONS } from '../../constants/permissions';
import { currentCasePermissions, editingCasePermissions } from '../../helpers/permissions';
import { getCurrentCasePermissions, getEditingCasePermissions } from '../cases/selector';

class Invite extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;
  static navigatorButtons = NavBar && {
    leftButtons: [NavBar.buttons.done],
  };

  constructor(props) {
    super(props);

    this.state = {
      pendingInvites: null,
    };

    this._unMounted = true;
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Invitations', 'Invite');
    Navigation.registerForButtonEvents(this);
    this._unMounted = false;
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this._unMounted = true;
    this.props.actions.resetState();
  }

  componentDidAppear(id) {
    this.getPendingInvites();
  }

  selectInviteType(type) {
    const { caseObj } = this.props;
    const caseId = caseObj && caseObj.caseId;
    let trackingString = 'Invitation';

    if (type == 'email') {
      Utils.trackEvent('Action', 'Tap', `${trackingString} Type`, 0);
      Navigation.push(
        {
          screen: 'InviteEmailPhone',
          title: I18n.ac('invite.inviteEmail'),
          passProps: {
            email_or_phone: 'email',
            caseId,
          },
        },
        this.props.componentId
      );
    } else if (type == 'phone') {
      Utils.trackEvent('Action', 'Tap', `${trackingString} Type`, 1);
      Navigation.push(
        {
          screen: 'InviteEmailPhone',
          title: I18n.ac('invite.inviteMobile'),
          passProps: {
            email_or_phone: 'phone',
            caseId,
          },
        },
        this.props.componentId
      );
    }
  }

  selectEmail = () => {
    this.selectInviteType('email');
  };
  selectPhone = () => {
    this.selectInviteType('phone');
  };

  componentDidUpdate(prevProps) {
    if (prevProps.caseObj !== this.props.caseObj) {
      this.getPendingInvites(true);
    }
  }

  getPendingInvites(clearPending) {
    if (!this.props.canView) return;

    if (clearPending && this.state.pendingInvites) this.setState({ pendingInvites: null });

    if (!this.props.caseObj) return;

    pendingInvitesForCase(this.props.caseObj.caseId)
      .then((invites) => {
        if (this._unMounted) return;

        const inviteHash = {};
        invites.forEach((invite) => {
          const inviteStr = invite.email || invite.phone;
          if (inviteStr) {
            inviteHash[inviteStr] = (inviteHash[inviteStr] || 0) + 1;
          }
        });

        const pendingInvites = Object.keys(inviteHash).map((iStr) => {
          return { label: iStr, count: inviteHash[iStr] };
        });
        this.setState({ pendingInvites });
      })
      .catch((e) => {
        console.error('error getting pendingInvitesForCase', e);
      });
  }

  renderPending = (pendingInvite, i) => {
    const borderTopStyle = i === 0 ? { borderTopWidth: 0 } : null;
    return (
      <View style={[styles.pendingRow, borderTopStyle]} key={i}>
        <View style={styles.pendingRowIndicator} />
        <Text style={styles.pendingLabel}>{pendingInvite.label}</Text>
      </View>
    );
  };

  successMessage() {
    return this.props.successMessage || this.props.initialSuccessMessage;
  }

  render() {
    if (!!this.props.caseObj && !this.props.canView) return <Container />;

    const pendingInvites = this.state.pendingInvites;

    return (
      <Container scrollView={true} successMessage={this.successMessage()}>
        {!!this.props.caseObj && (
          <View style={THEME.header}>
            <Text style={THEME.headerText}>{this.props.caseObj.name}</Text>
          </View>
        )}

        {!!this.props.canSend && (
          <View>
            <IconButton
              label={I18n.t('invite.usingEmailAddress')}
              imageSource={require('../../../resources/icon-email.png')}
              onPress={this.selectEmail}
              noTopBorder={true}
            />
            <IconButton
              label={I18n.t('invite.usingMobileNumber')}
              imageSource={require('../../../resources/icon-phone.png')}
              onPress={this.selectPhone}
              noTopBorder={true}
            />
          </View>
        )}

        {!!this.props.caseObj && (
          <View>
            <View style={styles.subHeader}>
              <Text style={styles.subHeaderText}>{I18n.t('invite.currentTribe')}</Text>
            </View>

            <Members editingCase={this.props.editingCase} />

            {!!(pendingInvites && pendingInvites.length) && (
              <View>
                <View style={styles.subHeader}>
                  <Text style={styles.subHeaderText}>
                    {I18n.t('invite.pendingInvites')} ({pendingInvites.length})
                  </Text>
                </View>
                <View>{pendingInvites.map(this.renderPending)}</View>
              </View>
            )}
          </View>
        )}

        {!this.props.caseObj && <ActivityOverlay sizeToScreen={true} />}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  subHeader: {
    justifyContent: 'center',
    paddingLeft: 20,
    height: 60,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    backgroundColor: COLOR.altContrast,
    borderColor: COLOR.accent,
  },
  subHeaderText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.large,
    color: COLOR.text,
  },
  pendingRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 25,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderColor: COLOR.accent,
  },
  pendingRowIndicator: {
    width: 14,
    height: 14,
    backgroundColor: COLOR.emphasis,
    borderRadius: 7,
  },
  pendingLabel: {
    flex: 1,
    ...FONT.regular,
    color: COLOR.text,
    fontSize: FONT_SIZE.regular,
    marginLeft: 20,
  },
});

function mapStateToProps(state, ownProps) {
  // use memoized getCurrentCase unless we've been opened via case info screen
  let caseObj;
  let canSend;
  let canView;

  // these are not referenced, just here to trigger the ui to refresh when permissions change
  const rawCurrentCasePermissions = getCurrentCasePermissions(state);
  const rawEditingCasePermissions = getEditingCasePermissions(state);

  if (ownProps.editingCase) {
    caseObj = getEditingCase(state);
    canSend = editingCasePermissions(INVITATIONS).canEdit;
    canView = editingCasePermissions(INVITATIONS).canView;
  } else {
    caseObj = getCurrentCase(state);
    canSend = currentCasePermissions(INVITATIONS).canEdit;
    canView = currentCasePermissions(INVITATIONS).canView;
  }

  return {
    caseObj,
    canSend,
    canView,
    successMessage: state.screens.invites.sendSuccessMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ resetState }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Invite);
